module.exports = __webpack_public_path__ + "img/user.d6c2eaea.svg";